import React from 'react';
import { Link } from 'react-router';

import { authContext } from '../AzureAd';
import { env, version } from '../config';

import 'admin-lte/dist/css/AdminLTE.css';
import 'admin-lte/dist/css/skins/_all-skins.min.css';
import '@fortawesome/fontawesome-free/css/all.css'

const $ = require('admin-lte/bower_components/jquery/dist/jquery.min.js');
window.$ = $;
window.jQuery = $;
require('bootstrap/dist/js/bootstrap.min.js');
require('admin-lte/dist/js/adminlte.min.js');

// 套版 AdminLTE 2，取代 MainComponent

export default class MainComponentLte extends React.Component {
	componentDidMount() {
		this.props.findAuthRoles();
	}

	packaging = () => {
		localStorage.setItem('category', 'pcakaging');
		this.props.forwardToSwitchFunctionCategory('packaging');
	}

	maintenance = () => {
		localStorage.setItem('category', 'maintenance');
		this.props.forwardToSwitchFunctionCategory('maintenance');
		//use by almost all functions later
		this.props.findCheckCategories();
	}

	render() {
		let user = authContext.getCachedUser();
		if (!user) {
			authContext.login();
		}
		let userName = user.profile.name;

		let roles = this.props.roles.toJS();
		// 包裝出貨
		let showCustomers = (roles.includes("ROLE_FIREFIGHTER_CUSTOMER_CRUD")
			|| roles.includes("ROLE_FIREFIGHTER_CUSTOMER_R")) ? '' : 'none';
		let showOrders = (roles.includes("ROLE_FIREFIGHTER_ORDER_CRUD")
			|| roles.includes("ROLE_FIREFIGHTER_ORDER_CRUD_LABOR")
			|| roles.includes("ROLE_FIREFIGHTER_ORDER_R")) ? '' : 'none';
		let showFitting = (roles.includes("ROLE_FIREFIGHTER_FITTING_CRUD")
			|| roles.includes("ROLE_FIREFIGHTER_FITTING_R")) ? '' : 'none';
		let showFittingApp = (roles.includes("ROLE_FIREFIGHTER_FITTING_CRUD")) ? '' : 'none';
		let showChipUpload = (roles.includes("ROLE_FIREFIGHTER_ADMIN")) ? '' : 'none';
		let showLabels = (roles.includes("ROLE_FIREFIGHTER_LABEL")) ? '' : 'none';
		let showPacking = (roles.includes("ROLE_FIREFIGHTER_PACKING")) ? '' : 'none';
		let showGearSpecs = (roles.includes("ROLE_FIREFIGHTER_SPEC_MODEL")) ? '' : 'none';
		let showGearModels = (roles.includes("ROLE_FIREFIGHTER_SPEC_MODEL")) ? '' : 'none';
		let showAdvancedSearch = (roles.includes("ROLE_FIREFIGHTER_ADVANCED_SEARCH")) ? '' : 'none';
		let showDownload = (roles.includes("ROLE_FIREFIGHTER_LABEL_DOWNLOAD")) ? '' : 'none';

		// 清洗維修
		let showMaintenanceOrder = (roles.includes("ROLE_MAINTENANCE_ORDER_EDIT") || roles.includes("ROLE_MAINTENANCE_ORDER_VIEW")) ? '' : 'none';
		let showMaintenanceCase = (roles.includes("ROLE_MAINTENANCE_CASE_EDIT") || roles.includes("ROLE_MAINTENANCE_CASE_PRICING") || roles.includes("ROLE_MAINTENANCE_CASE_CHECKING")) ? '' : 'none';
		let showMaintenanceCase2 = (roles.includes("ROLE_MAINTENANCE_CASE_FIXING")) ? '' : 'none';
		let showMaintenanceItem = (roles.includes("ROLE_MAINTENANCE_ITEM_EDIT")) ? '' : 'none';
		let showMaintenanceDownload = (roles.includes("ROLE_MAINTENANCE_CASE_DOWNLOAD")) ? '' : 'none';
		let showMaintenanceEpcSearch = (roles.includes("ROLE_MAINTENANCE_EPC_SEARCH")) ? '' : 'none';

		let packagingMenu = (
			<ul className="treeview-menu" style={{ paddingLeft: 25 }}>
				<li style={{ display: showCustomers }}><Link to="/customers">客戶管理</Link></li>
				<li style={{ display: showOrders }}><Link to="/orders">訂單管理</Link></li>
				<li style={{ display: showFitting }}><Link to="/fitting">套量管理</Link></li>
				<li style={{ display: showFittingApp }}><Link to="/fitting1">套量App管理</Link></li>
				<li style={{ display: showLabels }}><Link to="/labels">標籤管理</Link></li>
				<li style={{ display: showLabels }}><Link to="/labelOthers">標籤管理-頭套</Link></li>
				<li style={{ display: showAdvancedSearch }}><Link to="/advancedSearch">進階搜尋</Link></li>
				<li style={{ display: showPacking }}><Link to="/packing">裝箱管理</Link></li>
				<li style={{ display: showChipUpload }}><Link to="/chipUpload">晶片資料匯入</Link></li>
				<li style={{ display: showGearSpecs }}><Link to="/gearSpecs">料號管理</Link></li>
				<li style={{ display: showGearModels }}><Link to="/gearModels">型號|模版管理</Link></li>
				<li style={{ display: showDownload }}><Link to="/downloadItems">下載出貨資料</Link></li>
			</ul>
		);

		let maintenanceMenu = (
			<ul className="treeview-menu" style={{ paddingLeft: 25 }}>
				<li style={{ display: showCustomers }}><Link to="/customers">客戶管理</Link></li>
				<li style={{ display: showMaintenanceOrder }}><Link to="/maintainOrders">清洗標案管理</Link></li>
				<li style={{ display: showMaintenanceCase }}><Link to="/maintenanceCases">清點作業管理</Link></li>
				<li style={{ display: showMaintenanceCase }}><Link to="/refineCases">作業開工確認</Link></li>
				<li style={{ display: showMaintenanceCase2 }}><Link to="/fixing">維修作業</Link></li>
				<li style={{ display: showMaintenanceCase }}><Link to="/auditing">檢點作業</Link></li>
				<li style={{ display: showMaintenanceItem }}><Link to="/checkSetting">清洗項目管理</Link></li>
				<li style={{ display: showMaintenanceDownload }}><Link to="/downloadMPhotos">下載清洗資料</Link></li>
				<li style={{ display: showMaintenanceEpcSearch }}><Link to="/maintenanceSearch">清洗紀錄查詢</Link></li>
			</ul>
		);

		let logout = () => {
			authContext.logOut();
		};

		let envStyle = {
			color: 'red'
		};
		let title = (
			<span>開廣紡纖系統</span>
		)
		if (env !== '') {
			title = (
				<span><span style={envStyle}>({env})</span><span>紡纖系統</span></span>
			)
		}

		let currentYear = new Date().getFullYear();

		return (
			<div className="hold-transition skin-blue sidebar-mini">
				<div className="wrapper">
					<header className="main-header">

						<a href="/" className="logo">
							<span><img src="logo30.png" alt="taiwanKK" /><b style={{ paddingLeft: 10 }}>{title}</b></span>
						</a>

						<nav className="navbar navbar-static-top" role="navigation">
							<a href="#" className="sidebar-toggle" data-toggle="push-menu" role="button">
								<span className="sr-only">Toggle navigation</span>
							</a>
							<div className="navbar-custom-menu">
								<ul className="nav navbar-nav">
									<li className="dropdown user">
										<a className="dropdown-toggle">
											{userName}
										</a>
									</li>
									<li>
										<a href="#" onClick={logout} data-toggle="control-sidebar"><i className="glyphicon glyphicon-log-out"></i></a>
									</li>
								</ul>
							</div>
						</nav>

					</header>

					<aside className="main-sidebar">

						<section className="sidebar">

							<ul className="sidebar-menu" data-widget="tree">
								<li className="treeview">
									<a href="#"><i className="fa fa-ship"></i> <span>包裝出貨</span>
										<span className="pull-right-container">
											<i className="fa fa-angle-left pull-right"></i>
										</span>
									</a>
									{packagingMenu}
								</li>
								<li className="treeview">
									<a href="#"><i className="fa fa-gavel"></i> <span>清洗維修</span>
										<span className="pull-right-container">
											<i className="fa fa-angle-left pull-right"></i>
										</span>
									</a>
									{maintenanceMenu}
								</li>
							</ul>
						</section>
					</aside>

					<div className="content-wrapper">
						<section className="content container-fluid">
							<div style={{ paddingLeft: 20, paddingRight: 20 }}>
								{this.props.children}
							</div>
						</section>
					</div>

					<footer className="main-footer">
						<div className="pull-right hidden-xs">
							<a href="/doc/version_content.html" target="_blank"><span style={{ marginLeft: 20 }}>ver. {version}</span></a>
						</div>
						<strong>Copyright &copy; 2017-{currentYear} &nbsp;&nbsp;<a href="https://www.taiwankk.com.tw/" target="_blank">Taiwan K.K.</a></strong>  All rights reserved.
					</footer>

				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/MainComponentLte.jsx